import KTextField from "./KTextField";
import { formatGooglePlaceData } from "kinnect-formatters";
import { gmapApi } from "vue2-google-maps";

export default {
	name: "KGoogleAutocomplete",

	props: {
		country: {
			default: "us",
			type: [ String, Array ]
		},

		placeholder: String,

		types: {
			type: String,
			default: "address"
		}
	},

	data: () => ( {
		autocomplete: null
	} ),

	computed: {
		google: gmapApi
	},

	methods: {
		setupGoogle() {
			const inputEl = this.$el.querySelector( "input" );
			const options = {};

			if ( this.types ) {
				options.types = [ this.types ];
			}

			if ( this.country ) {
				options.componentRestrictions = {
					country: this.country
				};
			}

			this.autocomplete = new this.google.maps.places.Autocomplete(
				inputEl,
				options
			);

			// Placeholder can be set on the text field component
			inputEl.setAttribute( "placeholder", this.placeholder ? this.placeholder : "" );

			this.autocomplete.addListener( "place_changed", () => {
				const place = this.autocomplete.getPlace();
				const formattedPlace = formatGooglePlaceData( place );

				this.$emit( "placechanged", formattedPlace );
				this.$emit( "input", formattedPlace.name );
			} );
		}
	},

	mounted() {
		this.$gmapApiPromiseLazy().then( this.setupGoogle );
	},

	render() {
		return <KTextField
			attrs={this.$attrs}
			on={this.$listeners}
			placeholder={this.placeholder}
			scopedSlots={this.$scopedSlots}
		>
			{Object.keys( this.$slots ).map( slotName =>
				<template slot={slotName}>{this.$slots[slotName]}</template>
			)}
		</KTextField>;
	}
};
